let PreschoolLevels = /*#__PURE__*/function (PreschoolLevels) {
  PreschoolLevels[PreschoolLevels["DAYCARE"] = 0] = "DAYCARE";
  return PreschoolLevels;
}({});
let SchoolLevels = /*#__PURE__*/function (SchoolLevels) {
  SchoolLevels[SchoolLevels["KINDERGARTEN"] = 1] = "KINDERGARTEN";
  SchoolLevels[SchoolLevels["FIRST"] = 2] = "FIRST";
  SchoolLevels[SchoolLevels["SECOND"] = 3] = "SECOND";
  SchoolLevels[SchoolLevels["THIRD"] = 4] = "THIRD";
  SchoolLevels[SchoolLevels["FOURTH"] = 5] = "FOURTH";
  SchoolLevels[SchoolLevels["FIFTH"] = 6] = "FIFTH";
  SchoolLevels[SchoolLevels["SIXTH"] = 7] = "SIXTH";
  SchoolLevels[SchoolLevels["SEVENTH"] = 8] = "SEVENTH";
  SchoolLevels[SchoolLevels["EIGHT"] = 9] = "EIGHT";
  SchoolLevels[SchoolLevels["NINTH"] = 10] = "NINTH";
  SchoolLevels[SchoolLevels["TENTH"] = 11] = "TENTH";
  return SchoolLevels;
}({});
let HFLevels = /*#__PURE__*/function (HFLevels) {
  HFLevels[HFLevels["HF1"] = 12] = "HF1";
  HFLevels[HFLevels["HF2"] = 13] = "HF2";
  return HFLevels;
}({});
let HighschoolLevels = /*#__PURE__*/function (HighschoolLevels) {
  HighschoolLevels[HighschoolLevels["A"] = 14] = "A";
  HighschoolLevels[HighschoolLevels["B"] = 15] = "B";
  HighschoolLevels[HighschoolLevels["C"] = 16] = "C";
  return HighschoolLevels;
}({});
let CollegeLevels = /*#__PURE__*/function (CollegeLevels) {
  CollegeLevels[CollegeLevels["BASIC1"] = 17] = "BASIC1";
  CollegeLevels[CollegeLevels["BASIC2"] = 18] = "BASIC2";
  CollegeLevels[CollegeLevels["MAIN"] = 19] = "MAIN";
  CollegeLevels[CollegeLevels["ADULT"] = 20] = "ADULT";
  return CollegeLevels;
}({});
/**
 * Formats a level into a readable label, optionally separated into a prefix
 * and the basic label for a level-grouping which allows for shortening of
 * portal labels that contains several similar labels.
 */
function formatGradeLevel(level) {
  if (typeof level === "undefined") {
    return {
      label: ""
    };
  }
  switch (level) {
    case PreschoolLevels.DAYCARE:
      return {
        label: "Dagtilbud"
      };
    case SchoolLevels.KINDERGARTEN:
      return {
        prefix: "0.",
        label: "klasse"
      };
    case SchoolLevels.FIRST:
      return {
        prefix: "1.",
        label: "klasse"
      };
    case SchoolLevels.SECOND:
      return {
        prefix: "2.",
        label: "klasse"
      };
    case SchoolLevels.THIRD:
      return {
        prefix: "3.",
        label: "klasse"
      };
    case SchoolLevels.FOURTH:
      return {
        prefix: "4.",
        label: "klasse"
      };
    case SchoolLevels.FIFTH:
      return {
        prefix: "5.",
        label: "klasse"
      };
    case SchoolLevels.SIXTH:
      return {
        prefix: "6.",
        label: "klasse"
      };
    case SchoolLevels.SEVENTH:
      return {
        prefix: "7.",
        label: "klasse"
      };
    case SchoolLevels.EIGHT:
      return {
        prefix: "8.",
        label: "klasse"
      };
    case SchoolLevels.NINTH:
      return {
        prefix: "9.",
        label: "klasse"
      };
    case SchoolLevels.TENTH:
      return {
        prefix: "10.",
        label: "klasse"
      };
    case HFLevels.HF1:
      return {
        prefix: "1.",
        label: "HF"
      };
    case HFLevels.HF2:
      return {
        prefix: "2.",
        label: "HF"
      };
    case HighschoolLevels.A:
      return {
        prefix: "A",
        separator: "-",
        label: "niveau"
      };
    case HighschoolLevels.B:
      return {
        prefix: "B",
        separator: "-",
        label: "niveau"
      };
    case HighschoolLevels.C:
      return {
        prefix: "C",
        separator: "-",
        label: "niveau"
      };
    case CollegeLevels.BASIC1:
      return {
        label: "Grundforløb 1"
      };
    case CollegeLevels.BASIC2:
      return {
        label: "Grundforløb 2"
      };
    case CollegeLevels.MAIN:
      return {
        label: "Hovedforløb"
      };
    case CollegeLevels.ADULT:
      return {
        label: "Voksenuddannelse"
      };
  }
}

export { CollegeLevels, HFLevels, HighschoolLevels, PreschoolLevels, SchoolLevels, formatGradeLevel };
//# sourceMappingURL=model.js.map
